import { VmFilterRegistry } from '../agt.list.filter.ui.store';
import { AkumaAktionenVM } from '../agt.akumaaktionen.ui.store';
import { ISelectOpt } from 'app/components/common/Select';

// // Register AkumaAktionen specific filters
VmFilterRegistry.registerVmFilter('AkumaAktionenVM', {
	label: 'Aktionen',
	name: 'campaignId',
	type: 'MultiSelect',
	placeholderText: 'Aktion auswählen',
	vmType: 'AkumaAktionenVM',
	selectOpts: [], // Will be populated dynamically
	applyFilter: () => [0, 0], // Not used for VM filters
	dynamicSelectOpts: (vmItems: AkumaAktionenVM[]): ISelectOpt[] => {
		if (vmItems.length === 0) return [];
		const options: ISelectOpt[] = [{ label: 'Alle Aktion', value: '' }];
		vmItems[0].campaigns.forEach((campaign) => {
			options.push({ label: campaign.campaignName, value: campaign.id });
		});
		return options;
	},
	serverSideFilter: 'a.campaign_number in ({values})',
	vmContextFilter: (vmItem: AkumaAktionenVM, agt, value) => {
		return true;
	},
});

VmFilterRegistry.registerVmFilter('AkumaAktionenVM', {
	label: 'Top Aktionen',
	name: 'topCampaigns',
	type: 'checkbox',
	placeholderText: 'Nur Top Aktionen anzeigen',
	vmType: 'AkumaAktionenVM',
	applyFilter: () => [0, 0], // Not used for VM filters
	serverSideFilter: 'a.campaign_number in (select campaign_number from akumaaktionen_campaigns where top_campaign = 1)',
	vmContextFilter: (vmItem: AkumaAktionenVM, agt, value) => {
		return true;
	},
});

VmFilterRegistry.registerVmFilter('AkumaAktionenVM', {
	label: 'LOB Sach',
	name: 'campaignsSach',
	type: 'checkbox',
	placeholderText: 'Nur Sach anzeigen',
	vmType: 'AkumaAktionenVM',
	applyFilter: () => [0, 0], // Not used for VM filters
	serverSideFilter: 'a.campaign_number in (select campaign_number from akumaaktionen_campaigns where lob_sach = 1)',
	vmContextFilter: (vmItem: AkumaAktionenVM, agt, value) => {
		return true;
	},
});
VmFilterRegistry.registerVmFilter('AkumaAktionenVM', {
	label: 'LOB Leben',
	name: 'campaignsLeben',
	type: 'checkbox',
	placeholderText: 'Nur Leben anzeigen',
	vmType: 'AkumaAktionenVM',
	applyFilter: () => [0, 0], // Not used for VM filters
	serverSideFilter: 'a.campaign_number in (select campaign_number from akumaaktionen_campaigns where lob_leben = 1)',
	vmContextFilter: (vmItem: AkumaAktionenVM, agt, value) => {
		return true;
	},
});
VmFilterRegistry.registerVmFilter('AkumaAktionenVM', {
	label: 'LOB Kranken',
	name: 'campaignsKranken',
	type: 'checkbox',
	placeholderText: 'Nur Kranken anzeigen',
	vmType: 'AkumaAktionenVM',
	applyFilter: () => [0, 0], // Not used for VM filters
	serverSideFilter: 'a.campaign_number in (select campaign_number from akumaaktionen_campaigns where lob_kranken = 1)',
	vmContextFilter: (vmItem: AkumaAktionenVM, agt, value) => {
		return true;
	},
});

VmFilterRegistry.registerVmFilter('AkumaAktionenVM', {
	label: 'BA Privat',
	name: 'campaignsPrivat',
	type: 'checkbox',
	placeholderText: 'Nur Privat anzeigen',
	vmType: 'AkumaAktionenVM',
	applyFilter: () => [0, 0], // Not used for VM filters
	serverSideFilter: 'a.campaign_number in (select campaign_number from akumaaktionen_campaigns where ba_privat = 1)',
	vmContextFilter: (vmItem: AkumaAktionenVM, agt, value) => {
		return true;
	},
});
VmFilterRegistry.registerVmFilter('AkumaAktionenVM', {
	label: 'BA Firmen',
	name: 'campaignsFirmen',
	type: 'checkbox',
	placeholderText: 'Nur Firmen anzeigen',
	vmType: 'AkumaAktionenVM',
	applyFilter: () => [0, 0], // Not used for VM filters
	serverSideFilter: 'a.campaign_number in (select campaign_number from akumaaktionen_campaigns where ba_firmen = 1)',
	vmContextFilter: (vmItem: AkumaAktionenVM, agt, value) => {
		return true;
	},
});

// VmFilterRegistry.registerVmFilter('AkumaAktionenVM', {
// 	label: 'Top Kampagne',
// 	name: 'topCampaign',
// 	type: 'SingleSelect',
// 	placeholderText: 'Top Kampagne auswählen',
// 	vmType: 'AkumaAktionenVM',
// 	selectOpts: [
// 		{ label: 'Alle', value: '' },
// 		{ label: 'Nur Top Kampagnen', value: 'true' },
// 		{ label: 'Nur Standard Kampagnen', value: 'false' }
// 	],
// 	applyFilter: () => [0, 0], // Not used for VM filters
// 	vmContextFilter: (vmItem: AkumaAktionenVM, agt, value) => {
// 		if (!value || value === '') return true;
// 		const campaign = vmItem.campaigns.find(c => c.id === vmItem.item.campaignNumber);
// 		const isTop = campaign?.topCampaign === true;
// 		return value === 'true' ? isTop : !isTop;
// 	}
// });

// VmFilterRegistry.registerVmFilter('AkumaAktionenVM', {
// 	label: 'Focus Kampagne',
// 	name: 'focusCampaign',
// 	type: 'SingleSelect',
// 	placeholderText: 'Focus Kampagne auswählen',
// 	vmType: 'AkumaAktionenVM',
// 	selectOpts: [
// 		{ label: 'Alle', value: '' },
// 		{ label: 'Nur Focus Kampagnen', value: 'true' },
// 		{ label: 'Nur Standard Kampagnen', value: 'false' }
// 	],
// 	applyFilter: () => [0, 0], // Not used for VM filters
// 	vmContextFilter: (vmItem: AkumaAktionenVM, agt, value) => {
// 		if (!value || value === '') return true;
// 		const campaign = vmItem.campaigns.find(c => c.id === vmItem.item.campaignNumber);
// 		const isFocus = campaign?.focusCampaign === true;
// 		return value === 'true' ? isFocus : !isFocus;
// 	}
// });

// VmFilterRegistry.registerVmFilter('AkumaAktionenVM', {
// 	label: 'Sparte',
// 	name: 'lob',
// 	type: 'SingleSelect',
// 	placeholderText: 'Sparte auswählen',
// 	vmType: 'AkumaAktionenVM',
// 	selectOpts: [
// 		{ label: 'Alle Sparten', value: '' },
// 		{ label: 'Sach', value: 'sach' },
// 		{ label: 'Leben', value: 'leben' },
// 		{ label: 'Kranken', value: 'kranken' },
// 		{ label: 'Übergreifend', value: 'uebergreifend' },
// 		{ label: 'AGI', value: 'agi' },
// 		{ label: 'Wüstenrot', value: 'wuestenrot' },
// 		{ label: 'Sonstiges', value: 'sonstiges' }
// 	],
// 	applyFilter: () => [0, 0], // Not used for VM filters
// 	vmContextFilter: (vmItem: AkumaAktionenVM, agt, value) => {
// 		if (!value || value === '') return true;
// 		const campaign = vmItem.campaigns.find(c => c.id === vmItem.item.campaignNumber);
// 		if (!campaign) return false;
// 		debugger;

// 		switch (value) {
// 			case 'sach':
// 				return campaign.lobSach;
// 			case 'leben':
// 				return campaign.lobLeben;
// 			case 'kranken':
// 				return campaign.lobKranken;
// 			case 'uebergreifend':
// 				return campaign.lobUebergreifend;
// 			case 'agi':
// 				return campaign.lobAgi;
// 			case 'wuestenrot':
// 				return campaign.lobWuestenrot;
// 			case 'sonstiges':
// 				return campaign.lobSonstiges;
// 			default:
// 				return false;
// 		}
// 	}
// });

// VmFilterRegistry.registerVmFilter('AkumaAktionenVM', {
// 	label: 'Beratungsart',
// 	name: 'beratungsart',
// 	type: 'SingleSelect',
// 	placeholderText: 'Beratungsart auswählen',
// 	vmType: 'AkumaAktionenVM',
// 	selectOpts: [
// 		{ label: 'Alle Beratungsarten', value: '' },
// 		{ label: 'Firmen', value: 'firmen' },
// 		{ label: 'Privat', value: 'privat' },
// 		{ label: 'Sonstige', value: 'sonstige' }
// 	],
// 	applyFilter: () => [0, 0], // Not used for VM filters
// 	vmContextFilter: (vmItem: AkumaAktionenVM, agt, value) => {
// 		if (!value || value === '') return true;
// 		const campaign = vmItem.campaigns.find(c => c.id === vmItem.item.campaignNumber);
// 		if (!campaign) return false;

// 		switch (value) {
// 			case 'firmen':
// 				return campaign.baFirmen;
// 			case 'privat':
// 				return campaign.baPrivat;
// 			case 'sonstige':
// 				return campaign.baSonstige;
// 			default:
// 				return false;
// 		}
// 	}
// });

VmFilterRegistry.registerVmFilter('AkumaAktionenVM', {
	label: 'Min. Aktionen',
	name: 'minCampaigns',
	type: 'Input',
	placeholderText: 'Mindestanzahl Aktionen',
	vmType: 'AkumaAktionenVM',
	applyFilter: () => [0, 0], // Not used for VM filters
	vmContextFilter: (vmItem: AkumaAktionenVM, agt, value) => {
		if (!value) return true;
		const minCount = parseInt(value.toString());
		if (isNaN(minCount)) return true;
		return vmItem.item.countCampaigns >= minCount;
	},
});

// VmFilterRegistry.registerVmFilter('AkumaAktionenVM', {
// 	label: 'Min. Bearbeitungsquote (%)',
// 	name: 'minBearbeitungsquote',
// 	type: 'Input',
// 	placeholderText: 'Min. Bearbeitungsquote in %',
// 	vmType: 'AkumaAktionenVM',
// 	applyFilter: () => [0, 0], // Not used for VM filters
// 	vmContextFilter: (vmItem: AkumaAktionenVM, agt, value) => {
// 		if (!value) return true;
// 		const minQuote = parseFloat(value.toString());
// 		if (isNaN(minQuote)) return true;
// 		return vmItem.item.bearbeitungsQuote >= minQuote;
// 	}
// });
